<nz-form-item class="pf-form-item">
    @if (!!label && labelPosition === "left") {
        <nz-form-label
            class="pf-form-label"
            [nzRequired]="pfRequired"
            [nzNoColon]="true"
            [title]="label"
            [nzTooltipTitle]="tooltip"
            >{{ label }}
        </nz-form-label>
    }
    <nz-form-control class="pf-form-control" nzHasFeedback>
        <label
            #checkbox
            nz-checkbox
            [formControl]="formControl"
            class="pf-input">
            @if (labelPosition === "right") {
                <span>{{ label }}</span>
            }
        </label>
    </nz-form-control>
</nz-form-item>
